/**
 * Brand Logo Marquee — optional enhancement layer.
 *
 * The scroll animation itself is pure CSS (see section-brand-logo-marquee.css)
 * and works perfectly with this script disabled or blocked. The only thing
 * JS adds here is pausing each row's animation while it is off-screen, so
 * the browser isn't spending GPU/CPU cycles animating something nobody can
 * see (scroll it away, come back, and it just resumes).
 */

if (!customElements.get('logo-marquee')) {
  class LogoMarquee extends HTMLElement {
    connectedCallback() {
      if (!('IntersectionObserver' in window)) return;

      this.rows = Array.from(this.querySelectorAll('.logo-marquee__row'));
      if (!this.rows.length) return;

      this.observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            entry.target.classList.toggle('is-offscreen', !entry.isIntersecting);
          });
        },
        { rootMargin: '200px 0px' }
      );

      this.rows.forEach((row) => this.observer.observe(row));
    }

    disconnectedCallback() {
      if (this.observer) this.observer.disconnect();
    }
  }

  customElements.define('logo-marquee', LogoMarquee);
}
